export default "__VITE_ASSET__BG$sGP1e__"